<div class="c-footer u-ost-lg u-hidden@up-to-md" *ngIf="!vm.hideFooter() && vm.origin == 'minudoc.ee' && !vm.user?.previsitUser && !vm.previsitLocation">
	<div class="o-container">
		<div class="o-grid o-grid--wrap o-grid--center-v" *ngIf="vm.initialized">
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--o2@md-and-up">
				<a id="footerLogo" href="" class="c-footer__logo c-logo c-logo--main" [ngClass]="{'c-logo--en': vm.getGlobalProperty('session').user.deviceLanguage === 'en_GB', 'c-logo--et': vm.getGlobalProperty('session').user.deviceLanguage === 'et_EE', 'c-logo--ru': vm.getGlobalProperty('session').user.deviceLanguage === 'ru_RU', 'c-logo--fi': vm.getGlobalProperty('session').user.deviceLanguage === 'fi_FI'}" (click)="vm.reload()"></a>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up o-grid__cell--o3@md-and-up c-footer__cell">
				<ul class="c-list c-footer__list">
					<li class="c-list__item" *ngFor="let link of vm.links ; let $index=index">
						<a href="{{link.link}}" class="c-list__link c-text">{{ link.label }}</a>
					</li>
				</ul>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up c-footer__cell o-grid__cell--o1@md-and-up">
				<p class="c-text c-footer__text">Minudoc O&#220;, {{ 'Common.Reg_Code' | translate }} 14630213</p>
				<p class="c-text c-footer__text">{{ 'Address.Minudoc' | translate }}</p>
				<p class="c-text c-footer__text">+372 501 9568</p>
				<a href="mailto:{{vm.contactEmail}}" class="c-text c-text--main c-footer__text">{{vm.contactEmail}}</a>
			</div>
		</div>
	</div>
</div>
<div class="c-footer u-ost-lg u-hidden@up-to-md" *ngIf="!vm.hideFooter() && vm.origin == 'siffi.com' && !vm.user?.previsitUser && !vm.previsitLocation">
	<div class="o-container">
		<div class="o-grid o-grid--wrap o-grid--center-v" *ngIf="vm.initialized">
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--o2@md-and-up">
				<a href="javascript:void(0);" class="c-footer__logo c-logo c-logo--main c-logo--siffi-white" (click)="vm.reload()"></a>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up o-grid__cell--o3@md-and-up c-footer__cell">
				<ul class="c-list c-footer__list">
					<li class="c-list__item" *ngFor="let link of vm.links ; let $index=index">
						<a href="{{link.link}}" class="c-list__link c-text c-footer__siffi-text">{{ link.label }}</a>
					</li>
				</ul>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up c-footer__cell o-grid__cell--o1@md-and-up">
				<p class="c-text c-footer__text c-footer__siffi-text">{{ 'Address.Siffi' | translate }}</p>
				<p class="c-text c-footer__text c-footer__siffi-text">+372 501 9568</p>
				<a href="mailto:{{vm.contactEmail}}" class="c-text c-footer__text c-footer__siffi-text">{{vm.contactEmail}}</a>
			</div>
		</div>
	</div>
</div>
<div class="c-footer u-hidden@up-to-md" style="padding: 20px 0px" *ngIf="!vm.hideFooter() && vm.previsitLocation">
	<div class="o-container">
		<div class="o-grid o-grid--wrap o-grid--center-v" *ngIf="vm.initialized">
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--o2@md-and-up">
				<a href="javascript:void(0);" class="c-footer__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up o-grid__cell--o3@md-and-up c-footer__cell">
				<ul class="c-list c-footer__list">
					<li class="c-list__item" *ngFor="let link of vm.links ; let $index=index">
						<a href="{{link.link}}" target="_blank" class="c-list__link c-text">{{ link.label }}</a>
					</li>
				</ul>
			</div>
			<div class="o-grid__cell o-grid__cell--center-v o-grid__cell--w-100 o-grid__cell--w-fit@md-and-up c-footer__cell o-grid__cell--o1@md-and-up">
				<p class="c-text c-footer__text">Perearsti Tugiteenused O&#220;</p>
				<p class="c-text c-footer__text c-footer__siffi-text">{{ 'Address.Previsit' | translate }}</p>
				<p class="c-text c-footer__text c-footer__siffi-text">+372 5886 0188</p>
				<a href="mailto:{{vm.contactEmail}}" class="c-text c-footer__text c-text--main">{{vm.contactEmail}}</a>
			</div>
		</div>
	</div>
</div>
